
/**
 * Parse the query/search parameters in a given URL, or the current browser URL if no URL is
 * given.
 *
 * @param {string} url URL to parse parameters from
 *
 * @return {object}
 */
export function parseQueryParameters (url) {
    let queryParts = []
    const parameters = {}

    // ues the current browser URL if no specific URL was given
    if (url) {
        queryParts = url.split("&")
    } else {
        queryParts = window.location.search.slice(1).split("&")
    }

    for (const index in queryParts) {
        const [key, value] = queryParts[index].split("=")

        if (value !== undefined) {
            parameters[key] = decodeURIComponent(value)
        }
    }

    return parameters
}



// WEBPACK FOOTER //
// ./src/utilities/path.js